(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advertorial-draudhtlock"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.cs-dl').forEach(function(root){
    if(root.dataset.dlInitialized === 'true') return;
    root.dataset.dlInitialized = 'true';
    function q(s){return Array.prototype.slice.call(root.querySelectorAll(s))}
    var main=root.querySelector('.js-main'),th=q('.js-thumbs img'),cur=0;
    function go(i){if(!th.length||!main)return;cur=(i+th.length)%th.length;main.src=th[cur].getAttribute('data-full');main.alt=th[cur].alt;th.forEach(function(t,j){t.classList.toggle('is-on',j===cur)})}
    th.forEach(function(t,i){t.addEventListener('click',function(){go(i)})});
    q('.cs-dl__ar').forEach(function(b){b.addEventListener('click',function(){go(cur+parseInt(b.getAttribute('data-dir'),10))})});
    var st=347;
    function tick(){st=Math.max(41,st-1);q('.js-stock').forEach(function(e){e.textContent=st});setTimeout(tick,45000+Math.random()*75000)}
    setTimeout(tick,45000+Math.random()*75000);
    var bar=root.querySelector('.cs-dl__bar');
    if(bar){var hs=q('.js-hidebar'),vis=hs.map(function(){return false});
      function upd(){var top=root.getBoundingClientRect().top+window.scrollY;var any=window.scrollY<top+600;vis.forEach(function(v){if(v)any=true});bar.classList.toggle('is-off',any)}
      if('IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){vis[hs.indexOf(e.target)]=e.isIntersecting});upd()},{threshold:0.05});hs.forEach(function(h){io.observe(h)})}
      window.addEventListener('scroll',upd,{passive:true});upd()}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bleffy-venamed-thermo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(root) {
    if (!root || root.dataset.csVtInitialized === 'true') return;
    root.dataset.csVtInitialized = 'true';

    var galleryMain = root.querySelector('[data-gallery-main]');
    var big = galleryMain ? galleryMain.querySelector('img') : null;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.cs-vt__thumb'));
    var currentImageIndex = 0;

    function showGalleryImage(index) {
      if (!big || !thumbs.length) return;
      currentImageIndex = (index + thumbs.length) % thumbs.length;
      var activeThumb = thumbs[currentImageIndex];
      big.removeAttribute('srcset');
      big.src = activeThumb.dataset.src;
      big.alt = activeThumb.dataset.alt || '';
      thumbs.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === currentImageIndex);
      });
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { showGalleryImage(index); });
    });

    var previousGalleryButton = root.querySelector('[data-gallery-prev]');
    var nextGalleryButton = root.querySelector('[data-gallery-next]');
    if (previousGalleryButton) previousGalleryButton.addEventListener('click', function () { showGalleryImage(currentImageIndex - 1); });
    if (nextGalleryButton) nextGalleryButton.addEventListener('click', function () { showGalleryImage(currentImageIndex + 1); });
    if (thumbs.length <= 1) {
      if (previousGalleryButton) previousGalleryButton.hidden = true;
      if (nextGalleryButton) nextGalleryButton.hidden = true;
    }

    if (galleryMain && big && thumbs.length > 1) {
      var dragStartX = 0;
      var dragStartY = 0;
      var pointerDown = false;
      galleryMain.addEventListener('pointerdown', function (event) {
        if (event.target.closest('button')) return;
        pointerDown = true;
        if (galleryMain.setPointerCapture) galleryMain.setPointerCapture(event.pointerId);
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        galleryMain.classList.add('is-dragging');
      });
      galleryMain.addEventListener('pointerup', function (event) {
        if (!pointerDown) return;
        pointerDown = false;
        galleryMain.classList.remove('is-dragging');
        var deltaX = event.clientX - dragStartX;
        var deltaY = event.clientY - dragStartY;
        if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
          showGalleryImage(currentImageIndex + (deltaX < 0 ? 1 : -1));
        }
      });
      galleryMain.addEventListener('pointercancel', function () {
        pointerDown = false;
        galleryMain.classList.remove('is-dragging');
      });
      galleryMain.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') showGalleryImage(currentImageIndex + 1);
        if (event.key === 'ArrowLeft') showGalleryImage(currentImageIndex - 1);
      });
      galleryMain.setAttribute('tabindex', '0');
      galleryMain.setAttribute('aria-label', 'Galeria zdjęć produktu. Przesuń, aby zmienić zdjęcie.');
    }

    var dateElement = root.querySelector('[id^="cs-vt-date-"]');
    if (dateElement) {
      var date = new Date();
      var day = date.getDay();
      var daysToAdd = day === 5 ? 3 : (day === 6 ? 2 : 1);
      date.setDate(date.getDate() + daysToAdd);
      dateElement.textContent = date.toLocaleDateString('pl-PL', {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      });
    }

    var addButton = root.querySelector('.cs-vt__btn');
    var bundleHost = root.querySelector('[data-kaching-bundles]');

    function getKachingWidget() {
      if (!bundleHost) return null;
      return bundleHost.querySelector('kaching-bundles-block') || bundleHost.querySelector('kaching-bundle');
    }

    async function getFreshCartSections() {
      var response = await fetch(root.dataset.cartUrl + '?sections=cart-drawer,cart-icon-bubble', {
        method: 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('Could not refresh cart sections.');
      var sections = await response.json();
      if (!sections || !sections['cart-drawer']) throw new Error('Cart drawer section is missing.');
      return { sections: sections };
    }

    async function addSelectedBundle() {
      if (!addButton || addButton.disabled) return;
      var widget = getKachingWidget();
      if (!widget || typeof widget.items !== 'function') {
        console.error('Kaching Bundles widget is not ready or its items() method is unavailable.');
        return;
      }

      if (typeof widget.validateItemSelection === 'function') {
        var validation = widget.validateItemSelection();
        if (validation && validation.valid === false) return;
      }

      var items = widget.items();
      if (!Array.isArray(items) || !items.length) {
        console.error('Kaching Bundles did not return any selected items.');
        return;
      }

      addButton.disabled = true;
      var originalLabel = addButton.textContent;
      addButton.textContent = 'ADDING…';

      try {
        var response = await fetch(root.dataset.cartAddUrl + '.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: items,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        var responseText = await response.text();
        var result = null;

        if (responseText && responseText.trim()) {
          try {
            result = JSON.parse(responseText);
          } catch (parseError) {
            console.error('[Bleffy Thermo] Cart response was not valid JSON:', responseText);
            throw new Error('Shopify returned an unreadable cart response. Please refresh the page and try again.');
          }
        }

        if (!response.ok) {
          var errorMessage = result && (result.description || result.message);
          throw new Error(errorMessage || ('Cart request failed (HTTP ' + response.status + ').'));
        }

        // Some app/proxy responses may be empty. Refresh the cart sections instead
        // of attempting to parse an empty response as JSON.
        var cartData = result;
        if (!cartData || !cartData.sections || !cartData.sections['cart-drawer']) {
          cartData = await getFreshCartSections();
        }

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && typeof drawer.open === 'function') {
          drawer.renderContents(cartData);
          drawer.open();
        } else if (window.kachingCartApi && typeof window.kachingCartApi.openCart === 'function') {
          window.kachingCartApi.openCart({ refetchCart: true });
        } else {
          console.error('No compatible cart drawer was found. Cart items were added, but the drawer could not be opened.');
        }
      } catch (error) {
        console.error('[Bleffy Thermo] Add to cart failed:', error);
        alert(error.message || 'Could not add the selected bundle. Please try again.');
      } finally {
        addButton.disabled = false;
        addButton.textContent = originalLabel;
      }
    }

    if (addButton) addButton.addEventListener('click', addSelectedBundle);

    var comparison = root.querySelector('.cs-vt__cmp');
    if (comparison) {
      var range = comparison.querySelector('input[type="range"]');
      var overlay = comparison.querySelector('.cs-vt__cmp-over');
      var line = comparison.querySelector('.cs-vt__cmp-line');

      if (range && overlay && line) {
        range.addEventListener('input', function () {
          overlay.style.clipPath = 'inset(0 ' + (100 - range.value) + '% 0 0)';
          line.style.left = range.value + '%';
        });
      }
    }

    var sticky = root.querySelector('.cs-vt__sticky');
    var buyArea = root.querySelector('.cs-vt__main');
    if (sticky && buyArea) {
      var stickyButton = sticky.querySelector('button');
      if (stickyButton) {
        stickyButton.addEventListener('click', function () {
          buyArea.scrollIntoView({ behavior: 'smooth' });
        });
      }

      function updateSticky() {
        var bounds = buyArea.getBoundingClientRect();
        if (bounds.bottom <= 0) sticky.classList.add('is-on');
        else sticky.classList.remove('is-on');
      }

      window.addEventListener('scroll', updateSticky, { passive: true });
      updateSticky();
    }
  }

  function initAllSections(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-cs-vt]')) {
      initSection(context);
    }
    if (context.querySelectorAll) {
      context.querySelectorAll('[data-cs-vt]').forEach(initSection);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllSections(document);
    });
  } else {
    initAllSections(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllSections(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["groundguard-bleffy"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.cs-gg').forEach(function(root){

  var VARIANTS=[];
  var OPTS=[];
  try { VARIANTS=JSON.parse(root.getAttribute('data-variants') || '[]'); } catch(e) {}
  try { OPTS=JSON.parse(root.getAttribute('data-options') || '[]'); } catch(e) {}

  var main=root.querySelector('#cs-gg-main');
  root.querySelectorAll('.cs-gg__thumbs button').forEach(function(b){
    b.addEventListener('click',function(){
      if(main){main.src=b.getAttribute('data-src');main.removeAttribute('srcset');}
      root.querySelectorAll('.cs-gg__thumbs button').forEach(function(x){x.classList.remove('is-on');});
      b.classList.add('is-on');
    });
  });

  var ov=root.querySelector('[data-sg-ov]');
  if(ov){
    document.body.appendChild(ov);
    var close=function(){ov.classList.remove('is-open');document.body.style.overflow='';};
    root.querySelector('[data-sg-open]').addEventListener('click',function(){ov.classList.add('is-open');document.body.style.overflow='hidden';});
    ov.querySelector('[data-sg-close]').addEventListener('click',close);
    ov.addEventListener('click',function(e){if(e.target===ov)close();});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  }

  var t=root.querySelector('[data-timer]');
  if(t){
    var end;
    try{end=parseInt(sessionStorage.getItem('csGgTimer'),10);}catch(e){}
    if(!end||end<Date.now()){end=Date.now()+15*60*1000;try{sessionStorage.setItem('csGgTimer',end);}catch(e){}}
    var tick=function(){var s=Math.max(0,Math.floor((end-Date.now())/1000));t.textContent=String(Math.floor(s/60)).padStart(2,'0')+':'+String(s%60).padStart(2,'0');};
    tick();setInterval(tick,1000);
  }

  function selHtml(){
    var h='';
    OPTS.forEach(function(o,i){
      h+='<select data-oi="'+i+'" aria-label="'+o.name+'">';
      o.values.forEach(function(v){h+='<option value="'+v+'">'+v+'</option>';});
      h+='</select>';
    });
    return h;
  }
  var bundles=root.querySelectorAll('.cs-gg__bundle');
  bundles.forEach(function(b){
    var q=parseInt(b.getAttribute('data-qty'),10),rows=b.querySelector('[data-rows]'),h='';
    for(var i=1;i<=q;i++){h+='<div class="cs-gg__vrow"><span>#'+i+'</span>'+selHtml()+'</div>';}
    rows.innerHTML=h;
    b.addEventListener('click',function(e){
      if(e.target.tagName==='SELECT'||e.target.tagName==='OPTION')return;
      bundles.forEach(function(x){x.classList.remove('is-on');});
      b.classList.add('is-on');b.querySelector('input').checked=true;
    });
  });

  function findVariant(vals){
    for(var i=0;i<VARIANTS.length;i++){
      var v=VARIANTS[i],ok=true;
      for(var j=0;j<vals.length;j++){if(v.options[j]!==vals[j]){ok=false;break;}}
      if(ok)return v;
    }
    return null;
  }
  var atc=root.querySelector('[data-atc]');
  if(atc) atc.addEventListener('click',function(){
    var on=root.querySelector('.cs-gg__bundle.is-on');if(!on)return;
    var map={};
    on.querySelectorAll('.cs-gg__vrow').forEach(function(r){
      var vals=[];r.querySelectorAll('select').forEach(function(s){vals[parseInt(s.getAttribute('data-oi'),10)]=s.value;});
      var v=findVariant(vals);if(v){map[v.id]=(map[v.id]||0)+1;}
    });
    var items=Object.keys(map).map(function(id){return{id:parseInt(id,10),quantity:map[id]};});
    if(!items.length)return;
    var label=atc.textContent;atc.disabled=true;atc.textContent='Dodawanie...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json();})
      .then(function(){window.location.href='/cart';})
      .catch(function(){atc.disabled=false;atc.textContent=label;});
  });

  var top=root.querySelector('[data-top]');
  if(top){top.addEventListener('click',function(e){e.preventDefault();root.scrollIntoView({behavior:'smooth'});});}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
